import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  sortTodos, toggleHide, deleteAll, deleteDone,
} from '../actions/todosActions';

const Tools = () => {
  const todos = useSelector(state => state.todoApp);
  const dispatch = useDispatch();
  const cardsDoneLength = todos.filter(todo => todo.status === 'done').length;
  const cardsPendingLength = todos.filter(todo => todo.status === 'pending').length;
  const cardsHiddenLength = todos.filter(todo => todo.hidden === true).length;

  const handleToggleHide = () => {
    dispatch(toggleHide());
    dispatch(sortTodos());
  };
  const handleDeleteAll = () => {
    dispatch(deleteAll());
  };

  const handleDeleteDone = () => {
    dispatch(deleteDone());
  };

  return (
    <>

      {todos.length > 0
        ? (
          <div className="Tools__container">
            <div className="Todos__counter">
              <p>
                Pending:
                {cardsPendingLength}
              </p>
              <p>
                Done:
                {cardsDoneLength}
              </p>
            </div>
            <button type="button" onClick={handleDeleteAll} className="Todos__deleteAllButton">Delete All</button>
            {cardsDoneLength > 0
              ? (
                <>
                  <button type="button" onClick={handleDeleteDone} className="Todos__deleteDoneButton">Delete Done</button>
                  <button type="button" onClick={handleToggleHide} className="Todos__hideButton">{cardsHiddenLength > 0 ? 'Show Done' : 'Hide Done' }</button>
                </>
              )
              : ''}
          </div>
        )
        : ''}
    </>

  );
};

export default Tools;
